export default "__VITE_ASSET__CEMleAki__"